module.exports = __webpack_public_path__ + "static/media/C (5).442232bc.jpg";